import {useSelector, useDispatch} from 'react-redux';
import {actionSetConfig} from '../data/action';

export const useFilterAttributes = ()=>{
	if(typeof WP_OctaviusRocks_Admin !== typeof {} || typeof  WP_OctaviusRocks_Admin.extensions !== typeof {}) return []
	return WP_OctaviusRocks_Admin.extensions.filterAttributes || [];
}

export const useNumberOfDays =	( defaultValue, keyPrefix = "" ) =>{
	return useConfigInt( {defaultValue, key:`${keyPrefix}NumberOfDays`});
};
export const useNumberOfItems =	( defaultValue, keyPrefix = "") =>{
	return useConfigInt( {defaultValue, key: `${keyPrefix}NumberOfItems`});
};

export const useObjectConfig = (defaultValue, keyPrefix = "") => {
	return useConfigState({defaultValue, key: `${keyPrefix}_object`})
}

// ----------------------------
// private functions
// ----------------------------
const useConfigInt = ( {defaultValue = 0, key = "integer"} ) => {
	const [value, setValue] = useConfigState({defaultValue: parseInt(defaultValue), key});
	return [(typeof value === typeof 0)? value: defaultValue, _value => setValue(parseInt(_value))];
};
const useConfigState = ( { defaultValue = "", key = "value" }) => {
	const dispatch = useDispatch();
	const value = useConfig(key, defaultValue);
	return [ value,	_value => {
		dispatch(actionSetConfig(key, _value));
	}];
};
const useConfig = (key, defaultValue)=> useSelector(({config})=> config[key] || defaultValue);